export default __webpack_public_path__ + "static/media/farol.13520feb.svg";